import axios from 'axios'
import lscache from 'lscache'
import store from '@/store'
// import router from '@/router'
import { Toast } from 'vant'

const baseURL = (function () {
  if (process.env.NODE_ENV === 'development') {
    // 开发环境
    return '/rest'
    // return 'http://192.168.56.10:9912/rest'
  } else {
    // 正式环境
    // return 'https://yosdata.lessoald.cn/rest'
    return '/rest'
  }
})()

const service = axios.create({
  baseURL,
  timeout: 300000, // 请求超时时间
  headers: {
    Accept: 'application/x.yooshifu.v1+json'
  }
})

// request拦截器
service.interceptors.request.use(config => {
  store.commit('loading', true)
  let token = lscache.get('token')
  if (token) {
    config.headers.common.Authorization = 'Bearer ' + token
  }
  return config
}, error => {
  throw error
})

// respone拦截器
service.interceptors.response.use(
  response => {
    store.commit('loading', false)
    if (typeof response.headers.authorization !== 'undefined' &&
      response.headers.authorization) {
      lscache.set('token', response.headers.authorization.split(' ')[1], store.state.expired)
    }
    return response
  }
)

function request (method, url, conf, msg) {
  let config = conf
  config.url = url
  config.method = method

  return service
    .request(config)
    .then(response => {
      if (response.status === 200) {
        return response.data
      }
    })
    .catch(error => {
      store.commit('loading', false)
      if (error.response) {
        // console.log(error.response.data)
        // console.log(error.response.status)
        // console.log(error.response.headers)
        if (error.response.status === 401) {
          lscache.flush()
          window.location.href = '/auth/login'
          // router.push('/login')
          // Toast('登录超时，请重新登录！')
        }
        Toast('服务器返回数据错误，code：' + error.response.status)
      } else if (error.request) {
        // console.log('request error')
        // console.log(error.request)
        Toast('发起网络连接失败，请检查网络！')
      } else {
        // console.log('Error', error.message)
        Toast('网络连接失败！')
      }
      // 调用 refresh token 接口，避免下一次接口无法请求
      if (lscache.get('token')) {
        http.get('/rest/refresh')
      }
      // return Promise.reject(error)
    })
}

const http = {}
// msg 请求失败时提示信息
http.post = (url, config = {}) => {
  return request('post', url, config)
}
http.put = (url, config = {}) => {
  return request('put', url, config)
}
http.delete = (url, config = {}) => {
  return request('delete', url, config)
}

http.get = (url, config = {}) => {
  let conf = config
  if (!conf.params) conf.params = {}
  conf.params.nocache = +new Date()
  return request('get', url, config)
}

http.baseUrl = service.defaults.baseURL

export default {
  install (Vue, name = '$http') {
    Object.defineProperty(Vue.prototype, name, { value: http })
  }
}
